import { Navigate, Route, Routes } from "react-router-dom";
import ClientVendorDirectoryRankingDashboardPage from "./ClientVendorDirectoryRankingDashboardPage";
import ClientVendorDirectoryRankingModelListPage from "./ClientVendorDirectoryRankingModelListPage";
import ClientVendorDirectoryRankingModelDetailPage from "./ClientVendorDirectoryRankingModelDetailPage";
import ClientVendorDirectoryRankingRunListPage from "./ClientVendorDirectoryRankingRunListPage";
import ClientVendorDirectoryRankingSimulationListPage from "./ClientVendorDirectoryRankingSimulationListPage";
import ClientVendorDirectoryRankingOverrideListPage from "./ClientVendorDirectoryRankingOverrideListPage";
import ClientVendorDirectoryRankingPlacementListPage from "./ClientVendorDirectoryRankingPlacementListPage";
import ClientVendorDirectoryRankingPreviewPage from "./ClientVendorDirectoryRankingPreviewPage";

export default function ClientVendorDirectoryRankingHubPage() {
  return (
    <Routes>
      <Route index element={<ClientVendorDirectoryRankingDashboardPage />} />
      <Route path="modelos" element={<ClientVendorDirectoryRankingModelListPage />} />
      <Route path="modelos/:modelId" element={<ClientVendorDirectoryRankingModelDetailPage />} />
      <Route path="ejecuciones" element={<ClientVendorDirectoryRankingRunListPage />} />
      <Route path="simulaciones" element={<ClientVendorDirectoryRankingSimulationListPage />} />
      <Route path="exclusiones" element={<ClientVendorDirectoryRankingOverrideListPage />} />
      <Route path="colocaciones" element={<ClientVendorDirectoryRankingPlacementListPage />} />
      <Route path="preview" element={<ClientVendorDirectoryRankingPreviewPage />} />
      <Route path="*" element={<Navigate to="." replace />} />
    </Routes>
  );
}
